// ============================================================================
// SESSION MANAGEMENT CONSTANTS
// ============================================================================

// Start Session
export const START_SESSION_REQUEST = 'START_SESSION_REQUEST';
export const START_SESSION_SUCCESS = 'START_SESSION_SUCCESS';
export const START_SESSION_FAIL = 'START_SESSION_FAIL';
export const START_SESSION_RESET = 'START_SESSION_RESET';

// End Session
export const END_SESSION_REQUEST = 'END_SESSION_REQUEST';
export const END_SESSION_SUCCESS = 'END_SESSION_SUCCESS';
export const END_SESSION_FAIL = 'END_SESSION_FAIL';
export const END_SESSION_RESET = 'END_SESSION_RESET';

// Get Active Session
export const GET_ACTIVE_SESSION_REQUEST = 'GET_ACTIVE_SESSION_REQUEST';
export const GET_ACTIVE_SESSION_SUCCESS = 'GET_ACTIVE_SESSION_SUCCESS';
export const GET_ACTIVE_SESSION_FAIL = 'GET_ACTIVE_SESSION_FAIL';
export const GET_ACTIVE_SESSION_RESET = 'GET_ACTIVE_SESSION_RESET';

// Get Session Summary
export const GET_SESSION_SUMMARY_REQUEST = 'GET_SESSION_SUMMARY_REQUEST';
export const GET_SESSION_SUMMARY_SUCCESS = 'GET_SESSION_SUMMARY_SUCCESS';
export const GET_SESSION_SUMMARY_FAIL = 'GET_SESSION_SUMMARY_FAIL';
export const GET_SESSION_SUMMARY_RESET = 'GET_SESSION_SUMMARY_RESET';
